<template>
  <div class="params-detail v2-deviceEnergyHis">
    <div class="v2-waterP-content" style="width:98%;margin:35px auto">
      <span class="demonstration">时间</span>
      <el-date-picker v-model="start" :clearable="false" type="datetime" format="yyyy-MM-dd" :picker-options="pickerTimeOptions" placeholder="开始日期">
      </el-date-picker>
      <span class="spr-line"></span>
      <el-date-picker v-model="end" type="datetime" :clearable="false" format="yyyy-MM-dd" :picker-options="pickerTimeOptions" placeholder="结束日期">
      </el-date-picker>
      <el-button type="primary" @click="search">查询</el-button>
    </div>
    <div ref="deviceEnergyHis" id="deviceEnergyHis" class="deviceEnergyHis" style="height:70vh;width:98%;margin:25px auto">
    </div>
    <div v-if="show" class="nodata">
      <img src="../../assets/icon_data_empty.png" alt="">
      <span>该条件下暂无数据</span>
    </div>
  </div>
</template>

<script>
import equipmentV2 from '../../store/modules/equipmentV2'
import parameterV2 from '../../store/modules/parameterV2'
import { mapActions, mapMutations } from 'vuex'
import echarts from 'echarts'

export default {
  name: 'deviceEnergyHis',

  data () {
    return {
      equId: this.$route.query.equId,
      iotName: this.$route.query.iotName,
      show: false,
      start: new Date(new Date(new Date().toLocaleDateString()).getTime()),
      end: new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1),
      // 限制日期
      pickerTimeOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now() - 8.64e6
        }
      }
    }
  },
  mounted () {
    document.documentElement.style.fontSize = ''
    window.onresize = null
    this.setActiveTitle(`${this.$route.query.equName} 用电量分析`)
    if (this.$route.query.equId) {
      this.search()
    }
  },

  watch: {
    start (startDate) {
      this.start = this.$timeformat(new Date(new Date(startDate).toLocaleDateString()).getTime())// 00:00:00
      let a = new Date(startDate).getTime()
      const endTime = new Date(new Date(a).toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1 + 4 * 24 * 3600 * 1000
      const end = new Date(this.end).getDate()
      if (end > endTime || end < a) {
        this.end = endTime
      }
    },
    end (endDate) {
      this.end = this.$timeformat(endDate)
      let a = new Date(endDate).getTime()
      const start = new Date(this.start).getDate()
      const startTime = a - 4 * 24 * 3600 * 1000
      if (start < startTime || start > a) {
        this.start = startTime
      }
    }
  },

  methods: {
    ...mapMutations(equipmentV2, ['setActiveTitle']),
    ...mapActions(parameterV2, ['getDeviceEnergyHis']),
    async search () {
      let queryParams = {
        id: this.equId,
        iotName: this.iotName,
        type: 1,
        startTime: this.$timeformat(this.start),
        endTime: this.$timeformat(this.end)
      }
      const energyHisList = await this.getDeviceEnergyHis(queryParams)
      if (energyHisList && energyHisList.list && energyHisList.list.length) {
        this.show = false
      } else {
        this.show = true
      }
      this.loadEchart(energyHisList.list)
    },

    loadEchart (energyHisList) {
      let timeList = []
      let valueList = []
      energyHisList && energyHisList.forEach((item) => {
        timeList.push(item.time)
        valueList.push(item.electricity)
      })

      // 基于准备好的DOM初始化echarts实例
      const dom = this.$refs.deviceEnergyHis
      // 创建echarts实例
      let mycharts = echarts.init(dom)
      // 指定图表的配置项与数据
      mycharts.setOption({
        backgroundColor: 'rgba(175,201,255,.1)', // 背景色
        grid: {
          // 布局
          top: '14%',
          bottom: '12%',
          left: 40,
          right: 20,
          x: 80,
          y: 45,
          x2: 40,
          y2: 50,
          borderWidth: 1
        },
        tooltip: {
          // 悬浮框
          trigger: 'axis', //  item
          textStyle: {
            align: 'left'
          },
          formatter: function (params) {
            var result = ''
            for (var i = 0; i < params.length; i++) {
              result += params[i].name + '<br />'
              result += '用电量：' + params[i].value + ' KWh<br />'
            }
            return result
          }
        },
        legend: {
          tooltip: {
            trigger: 'item',
            show: true
          },
          itemGap: 30,
          bottom: '3%',
          icon: 'circle',
          itemWidth: 6,
          itemHeight: 6,
          textStyle: {
            color: 'rgba(255,255,255,1)',
            fontSize: 14,
            fontFamily: 'Microsoft YaHei'
          },
          x: 'center',
          data: this.nameList
        },
        color: ['#93C6FF', '#8F64FC', '#FF5898', '#FFCD57', '#3D5AFE', '#6ADAEE', '#00D478'],
        // x轴的配置项
        xAxis: {
          type: 'category',
          data: timeList,
          splitLine: {
            show: false
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: '#BBD4E9'
            }
          },
          axisTick: {
            // y轴刻度线
            show: false
          },
          axisLine: {
            lineStyle: {
              color: '#07f',
              width: 1 // 这里是为了突出显示加上的
            }
          }
        },
        yAxis: {
          type: 'value',
          splitLine: {
            show: false
          },
          axisTick: {
            // y轴刻度线
            show: false
          },
          axisLabel: {
            formatter: '{value}',
            textStyle: {
              color: '#BBD4E9'
            }
          },
          // 设置轴线的属性
          axisLine: {
            lineStyle: {
              color: '#07f',
              width: 1 // 这里是为了突出显示加上的
            }
          }
        },
        // 系列的设置：绘制什么样类型的图表、数据的展示在这里设置
        series: [
          // 柱状图
          {
            // 图表类型的设置
            type: 'bar',
            // 图表的数据 bar柱状图  line折线图 pie饼图
            data: valueList,
            color: '#93C6FF'
          }
        ]
      })
    }

  }
}
</script>

<style lang="stylus">
.v2-radio-group {
  display: flex;
  justify-content: flex-end;
  margin-right: 60px;

  .selecter-one {
    position: absolute;
    top: 16%;
    left: 50%;
    transform: translateX(-50%);
    z-index: 999;
  }

  .selecter-tow {
    position: absolute;
    top: 16%;
    right: 60px;
    z-index: 999;
  }

  .el-radio-group {
    border: 1px solid rgba(0, 119, 255, 1);
    z-index: 999;
    border-radius: 4px;
    overflow: visible;
    white-space: nowrap;
  }

  .el-radio-button__inner {
    background: none;
    border: none;
    font-size: 16px;
    color: #999999;
    white-space: nowrap;
    overflow: visible;
  }

  .el-radio-button + .el-radio-button .el-radio-button__inner {
    border-left: 1px solid rgba(0, 119, 255, 1);
  }

  .el-radio-button:first-child .el-radio-button__inner {
    border-left: none;
  }

  .el-radio-button__orig-radio:checked+.el-radio-button__inner {
    background: #0077ff;
    color: white;
  }

  .el-radio-button__inner:hover {
    color: #409EFF;
  }
}

.v2-deviceEnergyHis {
  position: relative;

  .nodata {
    img {
      position: absolute;
      top: 36%;
      left: 44%;
      width: 218px;
      height: 218px;
    }

    span {
      position: absolute;
      top: 70%;
      left: 45.5%;
      color: #6baae6;
      font-size: 20px;
    }
  }

  .el-date-picker {
    .el-date-picker__time-header {
      .el-input--small {
        input {
          color: #626262 !important;
          background: #fff !important;
        }
      }
    }

    .el-button--default {
      width: auto !important;
      background: #fff !important;
      color: #409EFF !important;
    }

    .el-button--primary {
      font-size: 16px;
      width: 120px;
      height: 36px;
      color: #fff;
      background: rgba(0, 119, 255, 1);
      border: 1px solid rgba(48, 145, 255, 1);
      border-radius: 4px;
      margin-right: 15px;
      padding: 10px 30px;
    }

    .el-button--success {
      font-size: 16px;
      width: 120px;
      height: 36px;
      color: #fff;
      margin-right: 15px;
      // padding: 10px 20px;
      border-radius: 4px;
      background: rgba(0, 181, 115, 1);
      border: 1px solid rgba(4, 12, 23, 1);
    }

    .input__inner {
    }

    .el-input--small {
      width: auto !important;
    }
  }

  .el-input {
    width: 156px;
    margin-right: 10px;
  }

  .el-input__inner {
    text-align: center;
    border: 1px solid #07f;
    color: #fff;
    background: none;
  }

  .el-button--primary {
    margin-left: 30px;
    padding: 10px 0px !important;
    width: 120px;
    height: 36px;
    font-size: 16px;
    background: rgba(0, 119, 255, 1);
    border: 1px solid rgba(48, 145, 255, 1);
    border-radius: 4px;
  }

  .el-button--success {
    width: 120px;
    height: 36px;
    padding: 10px 0px !important;
    font-size: 16px;
    background: rgba(0, 181, 115, 1);
    border: 1px solid #23CC8F;
    border-radius: 4px;
  }

  .demonstration {
    display: inline-block;
    width: 50px;
    margin-left: 10px;
    font-size: 14px;
    text-align: center;
    color: #BBD4E9;
  }

  .spr-line {
    display: inline-block;
    width: 12px;
    text-align: center;
    background: #07f;
    height: 1px;
    line-height: 40px;
    vertical-align: middle;
    margin-right: 10px;
  }
}
</style>
